import { render, staticRenderFns } from "./I-0-3-1-1__IR-Corporate Management12.vue?vue&type=template&id=6455f05a&"
import script from "./I-0-3-1-1__IR-Corporate Management12.vue?vue&type=script&lang=js&"
export * from "./I-0-3-1-1__IR-Corporate Management12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSpacer,VTextField})
